import { buildInfo, shortCommit } from '@brush/build-info';
import { AboutDialog, VersionBadge, apiVersionState } from '@brush/ui';
import { useState } from 'react';
import { useApiVersion } from '../queries';

/**
 * The version line at the foot of the Ledger rail, and the detail behind it.
 *
 * The open state lives here rather than in `@brush/ui` because the API's version is a request and
 * the request is what the open state gates — see `useApiVersion`.
 */
export function About() {
  const [open, setOpen] = useState(false);
  const version = useApiVersion(open);

  return (
    <>
      <VersionBadge
        version={buildInfo.version}
        commit={shortCommit(buildInfo.commit)}
        onClick={() => setOpen(true)}
        // AppShell renders its footer twice — in the ink-green rail from lg up, and under the
        // paper-ground content below it, where only one is ever visible. One colour would be
        // unreadable in one of the two, so the badge carries both.
        className="text-ink-800 hover:text-ink-950 lg:text-rail-300 lg:hover:text-white"
      />
      {open ? (
        <AboutDialog
          appLabel="Platform Admin console"
          client={buildInfo}
          api={apiVersionState(version)}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
